import { nothing as n } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const e = (i) => i != null ? i : n;
export {
  e as ifDefined
};
